var _excluded = ["allowReset"];

var _window;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createContext, useContext, useEffect } from "react";
import { Button } from "@blueprintjs/core";
import { useStoredState } from "./util/local-storage";
import h from "@macrostrat/hyper";
var ValueContext = /*#__PURE__*/createContext(null);
var UpdaterContext = /*#__PURE__*/createContext(null);
var matcher = (_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia("(prefers-color-scheme: dark)");

var systemDarkMode = function systemDarkMode() {
  var _matcher$matches;

  return {
    isEnabled: (_matcher$matches = matcher === null || matcher === void 0 ? void 0 : matcher.matches) !== null && _matcher$matches !== void 0 ? _matcher$matches : false,
    isAutoset: true
  };
};

var DarkModeProvider = function DarkModeProvider(props) {
  var _storedValue$isEnable, _storedValue$isAutose;

  var _props$addBodyClasses = props.addBodyClasses,
      addBodyClasses = _props$addBodyClasses === void 0 ? true : _props$addBodyClasses,
      children = props.children;

  var _useStoredState = useStoredState("ui-dark-mode", systemDarkMode()),
      _useStoredState2 = _slicedToArray(_useStoredState, 3),
      storedValue = _useStoredState2[0],
      updateValue = _useStoredState2[1],
      resetState = _useStoredState2[2]; // Guards so that we don't error on an invalid stored value


  var value = {
    isEnabled: (_storedValue$isEnable = storedValue === null || storedValue === void 0 ? void 0 : storedValue.isEnabled) !== null && _storedValue$isEnable !== void 0 ? _storedValue$isEnable : false,
    isAutoset: (_storedValue$isAutose = storedValue === null || storedValue === void 0 ? void 0 : storedValue.isAutoset) !== null && _storedValue$isAutose !== void 0 ? _storedValue$isAutose : false
  }; // Manage dark mode body classes

  useEffect(function () {
    if (!addBodyClasses) return;

    if (value.isEnabled) {
      document.body.classList.add("bp4-dark");
    } else {
      document.body.classList.remove("bp4-dark");
    }
  }, [storedValue]);

  var update = function update(enabled) {
    if (enabled == null) return resetState();
    var isEnabled = enabled !== null && enabled !== void 0 ? enabled : !value.isEnabled;
    updateValue({
      isAutoset: false,
      isEnabled: isEnabled
    });
  };

  useEffect(function () {
    var _matcher$addEventList;

    matcher === null || matcher === void 0 ? void 0 : (_matcher$addEventList = matcher.addEventListener) === null || _matcher$addEventList === void 0 ? void 0 : _matcher$addEventList.call(matcher, "change", function (e) {
      if (value.isAutoset) updateValue(systemDarkMode());
    });
  });
  return h(ValueContext.Provider, {
    value: value
  }, h(UpdaterContext.Provider, {
    value: update
  }, children));
};

var useDarkMode = function useDarkMode() {
  return useContext(ValueContext);
};

var inDarkMode = function inDarkMode() {
  var _useDarkMode$isEnable, _useDarkMode;

  return (_useDarkMode$isEnable = (_useDarkMode = useDarkMode()) === null || _useDarkMode === void 0 ? void 0 : _useDarkMode.isEnabled) !== null && _useDarkMode$isEnable !== void 0 ? _useDarkMode$isEnable : false;
};

var darkModeUpdater = function darkModeUpdater() {
  return useContext(UpdaterContext);
};

var DarkModeButton = function DarkModeButton(props) {
  var _props$allowReset = props.allowReset,
      allowReset = _props$allowReset === void 0 ? true : _props$allowReset,
      rest = _objectWithoutProperties(props, _excluded);

  var _useDarkMode2 = useDarkMode(),
      isEnabled = _useDarkMode2.isEnabled,
      isAutoset = _useDarkMode2.isAutoset;

  var icon = isEnabled ? "flash" : "moon";
  var update = darkModeUpdater();

  var onClick = function onClick(event) {
    if (allowReset && event.shiftKey) {
      update(null);
      return;
    }

    update(!isEnabled);
  };

  var active = !isAutoset;
  return h(Button, _objectSpread(_objectSpread({
    active: active
  }, rest), {}, {
    icon: icon,
    onClick: onClick
  }));
};

export { DarkModeProvider, useDarkMode, inDarkMode, darkModeUpdater, DarkModeButton };